import React from 'react';
import './App.css';
import BoulderGame from './components/BoulderGame';

function App() {
  return (
    <div className="App">
      <BoulderGame />
    </div>
  );
}

export default App;
